
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import Virtual from '@models/games/Virtual';
import IVirtualDto from './dtos/IVirtualDto';

const unwantedUrlPrefix = 'pariuri-virtuale/';

export default class VirtualMapper extends AbstractMapper<IVirtualDto, Virtual> {
    createTargetObject(gameDto: IVirtualDto): Virtual {
        const game = new Virtual();
        game.name = gameDto.name;
        // url recived from games API constains unwanted part ('pariuri-virtuale')
        // we remove that part and use only important part of given url (gameId)
        // slice(1) removes first array element
        game.redirectUrl = gameDto.webGameUrl.replace(unwantedUrlPrefix, '');
        game.fullGameUrl = gameDto.fullGameUrl;
        game.fullMobileGameUrl = gameDto.fullGameUrlMobile;
        game.demoGameUrl = gameDto.demoGameUrl;
        game.additionalParams = gameDto.aditionalParams;
        game.checkOriginUrl = gameDto.checkOriginUrl;
        // all images are stored and exposed with resolution 90px
        // we need manually switch to 223px
        game.imageSrc = gameDto.imgsrc ? gameDto.imgsrc.replace('_90.', '_223.') : '';
        game.test = gameDto.test || false;
        game.description = gameDto.description;
        game.isNew = gameDto.new;
        return game;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/VirtualMapper.ts